import { Link } from "react-router-dom";
import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function SolutionsFinalCTA() {
  const { open } = useDemoRequest();
  return (
    <section className="py-16 md:py-20 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            See StackMap in Your Business
          </h2>
          <p className="text-base md:text-lg text-silver-300 mb-8 max-w-xl mx-auto">
            Schedule a personalized demo tailored to your operational challenges and business goals.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={open} className="btn-primary w-full sm:w-auto text-center whitespace-nowrap cursor-pointer">
              Book a Demo
            </button>
            <Link
              to="/products"
              className="btn-outline w-full sm:w-auto text-center whitespace-nowrap"
            >
              Explore Products
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}